<template>
  <div class="progress-bar flex justify-content-between align-items-center">
    <div class="bar relative-wrap">
      <div class="yellow-heart" :style="{width: `${progress}%`}"></div>
    </div>
    <div class="count">{{progress}}%</div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: [Number, String],
      default: 60
    }
  }
}
</script>

<style lang="less" scoped>
  .progress-bar {
    padding: 14px 0 11px;
  }
  .bar {
    width:275px;
    height:14px;
    background:rgba(236,236,236,1);
    border-radius:10px;
    .yellow-heart {
      width: 60%;
      height: 100%;
      background: rgba(253,208,106,1);
      border-radius: 10px;
      position: absolute;
      top: 0;
      left: 0;
      &::after {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        background: rgba(255,255,255,1);
        border-radius: 50%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 8px;
      }
    }
  }
  .count {
    color: #FDD06A;
    font-size: 15px;
  }
</style>